import * as fromRoot from '../../../state/app.reducer';
import { createFeatureSelector, createSelector } from '@ngrx/store';
import { EaselActions, EaselActitonTypes } from './easel.actions';
import { Easel } from '../../../_models/easel';
import { EaselType } from '../../../_models/easel_type';
import { EaselFamily } from '../../../_models/easel_family';
import { Product } from '../../../_models/product';

export interface State extends fromRoot.State {
	easels: EaselState;
}

export interface EaselState {
  currentEaselId: bigint | null;
  currentEasel: Easel;
	easelList: Easel[];
	easelTypes: EaselType[];
	easelFamilies: EaselFamily[];
	freightList: Product[];
	filterFields: any;
	error: string;
}

const initialItem: Easel = {
  id: null,
  name: '',
	desc: null,
	type: null,
	family: null,
	sides: 1,
	stacks: 1,
	height: 0,
	width: 0,
	depth: 0,
	weight: 0,
	max_height: 0,
	max_width: 0,
	max_weight: 0,
	safety_margin: 0,
	id_freight: null,
  utilization: 0,
  thickness: 0,
  separator: 0,
  stack_distance: 0,
  priority: 999,
	cost_m3: 0,
	active: true
};

const initialState: EaselState = {
  currentEaselId: null,
  currentEasel: initialItem,
  easelList: [],
	easelTypes: [],
	easelFamilies: [],
  freightList: [],
  filterFields: [],
  error: ''
};

const getEaselFeatureState = createFeatureSelector<EaselState>('easels');

export const getCurrentEaselId = createSelector(
	getEaselFeatureState,
	state => state.currentEaselId
);

export const getCurrentEasel = createSelector(
    getEaselFeatureState,
    getCurrentEaselId,
    (state, currentEaselId) => {
        if (currentEaselId == null) {
            return initialItem;
        } else {
            return currentEaselId ? state.easelList.find(p => p.id === currentEaselId) : null;
        }
    }
);

export const getEaselList = createSelector(
	getEaselFeatureState,
	state => state.easelList
);

export const getFilterFields = createSelector(
	getEaselFeatureState,
	state => state.filterFields
);

export const getError = createSelector(
	getEaselFeatureState,
	state => state.error
);

export const getEaselTypes = createSelector(
  getEaselFeatureState,
  state => state.easelTypes
);

export const getEaselFamilies = createSelector(
  getEaselFeatureState,
  state => state.easelFamilies
);

export const getFreightList = createSelector(
  getEaselFeatureState,
  state => state.freightList
);

// Primer parámetro es el "estado ngrx" almacenado en ese momento.
// Segundo parámetro es la acción que se va a procesar.
export function reducer(state = initialState, action: EaselActions): EaselState {

	// console.log('--> Easel Reduce --> Estado actual: ' + JSON.stringify(state));
	// console.log('--> Action Easel type: ');
	// console.log(action.type);

	switch (action.type) {

		case EaselActitonTypes.SetCurrentEasel:

			console.log('--> Entando en acción SetCurrentEasel.');

			if (action.payload !== null) {

				return {
					...state,
					currentEaselId: action.payload.id,
					currentEasel: action.payload
				};
			} else {
				return {
					...state,
					currentEaselId: null,
					currentEasel: initialItem
				};
			}

		case EaselActitonTypes.SetCurrentEaselId:

			console.log('--> Entando en acción SetCurrentEasel.');

			return {
                ...state,
				currentEaselId: action.payload
			};

		case EaselActitonTypes.SetFilterFields:

			console.log('--> Entando en acción SetFilterFields.');

			return {
                ...state,
                filterFields: action.payload
			};

        case EaselActitonTypes.GetCurrentEasel:

			console.log('--> Entando en acción GetCurrentEasel.');

			return state;

		case EaselActitonTypes.ClearEasel:

			console.log('--> Entando en acción ClearEasel.');

			return {
					...state,
					currentEaselId: null
				};


		case EaselActitonTypes.InicializeEasel:

			console.log('--> Entando en acción InicializeEasel.');

			state = initialState;

			return state;


		case EaselActitonTypes.LoadEaselsSuccess:

			console.log('--> Entando en acción LoadEaselsSuccess. => Payload = ');
			// console.log(action.payload);

			return {
					...state,
					easelList: action.payload,
					error: ''
				};

		case EaselActitonTypes.LoadEaselsFail:

			console.log('--> Entando en acción LoadEaselsFail. => Payload = ');
			console.log(action.payload);

			return {
					...state,
					easelList: [],
					error: action.payload
				};

		// case EaselActitonTypes.UpdateEasel:

		// 	console.log('--> Entando en acción UpdateEasel.');

		// 	// state = initialState;

		// 	return state;

		case EaselActitonTypes.UpdateEaselSuccess:

			console.log('--> Entando en acción UpdateEaselSuccess.');

			// Se actualiza en los proyectos actuales el proyecto que se ha modificado y el resto se deja como estaba.

			let auxEaselList = [];

			if (action.payload !== undefined) {
				console.log(' -> El proyecto a modificar es:');
				console.log(action.payload);

				if (action.payload != null) {
					auxEaselList = state.easelList.map(
					item => action.payload.id === item.id ? action.payload : item);

					return {
						...state,
						easelList: auxEaselList,
						currentEaselId: action.payload.id,
						error: ''
					};
				}

				return state;

			} else {
				console.log(' -> La obra a modificar está vacía.');

				return {
					...state,
					error: 'No se ha podido modificar la obra.'
				};
			}

		case EaselActitonTypes.UpdateEaselFail:

			console.log('--> Entrando en acción UpdateEaselFail.');

			return {
					...state,
					error: action.payload
				};

		case EaselActitonTypes.CreateEaselSuccess:

			console.log('--> Entrando en acción CreateEaselSuccess.');

			// Se actualiza en los elementos actuales añadiendo a la lista el que se ha creado.
			// this.currentEasels = null;

			if (action.payload !== undefined) {
				console.log(' -> El elemento creado es:');
				console.log(action.payload);

				if (action.payload !== null) {

					state.easelList.push(action.payload);

					return {
						...state,
						easelList: state.easelList,
						currentEaselId: action.payload.id,
						error: ''
					};
				}

				return state;

			} else {
				console.log(' -> El elemento a crear está vacío.');

				return {
					...state,
					currentEaselId: null,
					error: 'No se ha podido crear el elemento.'
				};
			}

		case EaselActitonTypes.CreateEaselFail:

			console.log('--> Entrando en acción CreateEaselFail.');

			return {
					...state,
					currentEaselId: null,
					error: action.payload
				};

		case EaselActitonTypes.DeleteEaselSuccess:

			console.log('--> Entrando en acción DeleteEaselSuccess.');

			if (action.payload !== undefined) {
				console.log(' -> El caballete borrado con éxito es:');
				console.log(action.payload);

				if (action.payload != null) {

					const filterList = state.easelList.filter((item) => item.id.toString() !== action.payload.toString());

					console.log(' -> Lista filtrada de caballetes:');
					console.log(filterList);

					return {
						...state,
						easelList: filterList,
						currentEaselId: null,
						error: ''
					};
				}

				return state;

			} else {
				console.log(' -> El caballete a borrar está vacío.');

				return {
					...state,
					currentEaselId: null,
					error: 'No se ha podido borrar el caballete.'
				};
			}

		case EaselActitonTypes.DeleteEaselFail:

			console.log('--> Entrando en acción DeleteEaselSuccess.');

			return {
					...state,
					currentEaselId: null,
					error: action.payload
				};

			// Tipos de caballetes

    case EaselActitonTypes.LoadAllTypesSuccess:

      console.log('--> Entrando en acción LoadAllTypesSuccess. => Payload = ');
      console.log(action.payload);

      return {
        ...state,
        easelTypes: action.payload,
        error: ''
      };

    case EaselActitonTypes.LoadAllTypesFail:

      console.log('--> Entrando en acción LoadAllTypesFail. => Payload = ');
      console.log(action.payload);

      return {
        ...state,
        easelTypes: [],
        error: action.payload
			};

			// Familias de caballetes

    case EaselActitonTypes.LoadFamiliesSuccess:

      console.log('--> Entrando en acción LoadFamiliesSuccess. => Payload = ');
      console.log(action.payload);

      return {
        ...state,
        easelFamilies: action.payload,
        error: ''
      };

    case EaselActitonTypes.LoadFamiliesFail:

      console.log('--> Entrando en acción LoadFamiliesFail. => Payload = ');
      console.log(action.payload);

      return {
        ...state,
        easelFamilies: [],
        error: action.payload
      };


      // Freights

    case EaselActitonTypes.LoadFreightsSuccess:

      console.log('--> Entrando en acción LoadFreightsSuccess. => Payload = ');
      console.log(action.payload);

      return {
        ...state,
        freightList: action.payload,
        error: ''
      };

    case EaselActitonTypes.LoadFreightsFail:

      console.log('--> Entrando en acción LoadFreightsFail. => Payload = ');
      console.log(action.payload);

      return {
        ...state,
        freightList: [],
        error: action.payload
      };

		default:
			return state;
	}
}
